import api from './api';

export interface User {
  id: string;
  userName: string;
  nome: string;
  phoneNumber: string;
  tipoUsuario: string;
  grupos: Grupo[];
  centrosCusto: any[];
}

export interface Grupo {
  descricao: string;
  nome: string;
  id: string;
  dataCriacao: string;
  ativo: boolean;
  usuarios: User[];
  permissoes: Permissao[];
}
export interface Permissao {
  descricao: string;
  nome: string;
  id: string;
  dataCriacao: string;
  ativo: boolean;
}
export interface Filtros {
  TermoBusca: string;
  OrdenacaoDesc: boolean;
  PageSize: number;
  PageNumber: number;
  Ativo: boolean;
  DataInicio?: Date;
  DataFim?: Date;
}

export function incluirGrupo(data: Grupo) {
  return api.post('grupo', data);
}

export function vincularGrupoUsuario(data: any) {
  return api.post('grupo/vincularGrupoUsuario', data);
}

export function updateGrupo(data: Grupo) {
  return api.put('grupo', data);
}

export function listarGrupos(params?: any) {
  return api.get('grupo/listargrupos', { params });
}

export function listarUsuariosGrupos(Id: string) {
  return api.get('grupo/listarusuariogrupo', { params: { Id } });
}

export function getGrupoById(Id: string) {
  return api.get('grupo/grupogetbyid', { params: { Id } });
}

export function AtivarOuDesativar(data: any) {
  return api.put('grupo/AtivarOuDesativar', data);
}

export function AtivarOuDesativarUsuarioGrupo(data: any) {
  return api.put('grupo/AtivarOuDesativarVinculoUsuario', data);
}

export function ListarPermissoesGrupo(Id: string) {
  return api.get('grupo/listarpermissoesgrupo', { params: { Id } });
}

export function ListarPermissoes(params: any) {
  return api.get('permissao/listarpermissoes', {params});
}

export function vincularPermissaoGrupo(data: any) {
  return api.post('permissao/vincularpermissaogrupo', data);
}

export function ativarOuDesativarVinculoPermissao(data: any) {
  return api.put('permissao/AtivarOuDesativarVinculoPermissao', data);
}

export function ObterMenu(IdGrupo: any) {
  return api.get('seguranca/ObterMenu', { params: { IdGrupo } });
}

export function listarGruposComPermissao(params?: any) {
  return api.get('grupo/listarComboGruposComPermissao', { params });
}
